import * as React from 'react'
// eslint-disable-next-line import/no-internal-modules
import '../common/styles/login.css'
import LoginForm from './LoginForm'
import RightSidebar from './RightSidebar'
import { ForgetPasswordDesktop, ForgetPasswordMobile } from './ForgetPassword'

const Login = () => {
	React.useEffect(() => {
		document.title = 'Login'
	}, [])

	const style = {
		background: `linear-gradient(270deg, #00000000 60%, #000000ad 100%),
				linear-gradient(90deg, #00000000 60%, #000000ad 100%),
				url('/images/readpeak_background_new.jpg') transparent 0% 0% no-repeat padding-box`,
		width: '100%',
		minHeight: '100vh',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		opacity: '1',
	}

	return (
		<>
			<div id="bg" style={style}>
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-6 col-sm-6 col-xs-12 col-size">
							<LoginForm />
							<ForgetPasswordMobile />
						</div>
						<RightSidebar />
					</div>
					<ForgetPasswordDesktop />
				</div>
			</div>
		</>
	)
}

export default Login
